import React from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import appConstant from '../../../../constants/app';

const onClickTrendingLink = (e, linkId) => {
  axios({
    method: 'post',
    url: `${appConstant.API_URL}/link/click`, 
    data: {
      id: linkId,
    },
  })
  .then(res => {
  }).catch(err => {
    console.log(err);
  });
}

const SectionGroup = (props) => (
  <Row className="section-accordion-row">
    <Col className="section-accordion-col" xs={12}>
      <label className="section-accordion-label">{props.item.label}</label>
      {props.item.links.map((link, index) => (
        <p className="section-accordion-paragraph" key={`group-${link.id}`}>
          <a
            onClick={(e) => {
              onClickTrendingLink(e, link.id)
            }}
            target="_blank"
            rel="noopener noreferrer"
            href={link.url}
          >
            {link.label}
          </a>
        </p>
      ))}
    </Col>
  </Row>
)

export default SectionGroup;



// WEBPACK FOOTER //
// ./src/app/screens/landing/sections/sectionGroup.js